/**
 * Submit a signed form to a payment provider via POST.
 *
 * The server returns { redirect_url, params } where params contains
 * RSA-SHA256-signed fields (IPCPurchase). A simple redirect would send
 * a GET without any of those fields — the provider would reject it.
 *
 * This utility creates a hidden form with one input per entry of params,
 * submits it as POST, and the browser leaves the page.
 *
 * IMPORTANT: params must be forwarded verbatim — reordering, filtering,
 * or modifying any value invalidates the Signature.
 *
 * @deprecated Used by the myPOS payment gateway only. PostFinance Checkout
 * returns a plain redirect_url (no params). This function is kept for
 * backward compatibility during the migration period. Remove once myPOS
 * is fully decommissioned and no checkout response includes `params`.
 */
export function submitSignedForm(
  redirectUrl: string,
  params: Record<string, string>,
): void {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = redirectUrl;
  form.style.display = 'none';

  for (const [key, value] of Object.entries(params)) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = String(value);
    form.appendChild(input);
  }

  document.body.appendChild(form);
  form.submit();
}
